// extracted by mini-css-extract-plugin
export default {"socialContainer":"Social_socialContainer__E3phj","socialGrid":"Social_socialGrid__RzK93","socialLink":"Social_socialLink__zUx--","iconWrapper":"Social_iconWrapper__6GiFb"};